import {documentToReactComponents} from '@contentful/rich-text-react-renderer'
import {BLOCKS} from '@contentful/rich-text-types'
import {Card} from '@primer/react-brand'
import {getPrimerIcon} from '../octicons'

import type {PrimerComponentCard} from '../../../lib/types/contentful'

export type ContentfulCardProps = {
  component: PrimerComponentCard

  /**
   * The props below do not have a corresponding field in Contentful:
   */
  className?: string
}

export const ContentfulCard = ({component, className}: ContentfulCardProps) => {
  const Octicon = getPrimerIcon(component.fields.icon)
  const iconColor = component.fields.iconColor || 'default'
  const hasBackground = component.fields.iconBackground

  return (
    <Card href={component.fields.href} ctaText={component.fields.ctaText} className={className}>
      {Octicon && (
        <Card.Icon
          data-testid={`${component.fields.icon}-${component.fields.href}`}
          icon={<Octicon />}
          color={iconColor}
          hasBackground={hasBackground}
        />
      )}

      <Card.Heading>{component.fields.heading}</Card.Heading>

      {component.fields.label && <Card.Label>{component.fields.label}</Card.Label>}

      {component.fields.description &&
        documentToReactComponents(component.fields.description, {
          renderNode: {
            [BLOCKS.PARAGRAPH]: (_, children: React.ReactNode) => <Card.Description>{children}</Card.Description>,
          },
        })}
    </Card>
  )
}

try{ ContentfulCard.displayName ||= 'ContentfulCard' } catch {}
try{ Octicon.displayName ||= 'Octicon' } catch {}